module.exports = __webpack_public_path__ + "img/4-fontane-pirotecniche.d1acde7a.jpg";